import { c as _c } from "react/compiler-runtime";
import { useI18n, useFormatNumber } from '@udemy-v2/i18n';

/**
 * Hook that provides a function to format content length text
 * Mimics the Python implementation of get_content_length_text
 * @returns A function that takes minutes and returns formatted text
 */
export function useContentLengthFormatter() {
  const $ = _c(3);
  const {
    ninterpolate
  } = useI18n();
  const {
    formatNumber
  } = useFormatNumber();
  let t0;
  if ($[0] !== formatNumber || $[1] !== ninterpolate) {
    t0 = minutes => {
      const roundedMinutes = Math.round(minutes);
      let hours = Math.floor(roundedMinutes / 60);
      let remainingMinutes = roundedMinutes % 60;
      if (remainingMinutes >= 15) {
        const halfHours = Math.floor((remainingMinutes + 15) / 30) / 2;
        hours = hours + halfHours;
        if (halfHours > 0) {
          const originalMinutes = remainingMinutes;
          remainingMinutes = 0;
          if (hours < 1 && halfHours === 0.5) {
            return ninterpolate("%(minutes)s min", "%(minutes)s mins", originalMinutes, {
              minutes: originalMinutes
            });
          }
        }
      }
      if (hours < 1) {
        return ninterpolate("%(minutes)s min", "%(minutes)s mins", remainingMinutes, {
          minutes: remainingMinutes
        });
      } else {
        return ninterpolate("%(hours)s hour", "%(hours)s hours", hours, {
          hours: formatNumber(hours)
        });
      }
    };
    $[0] = formatNumber;
    $[1] = ninterpolate;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const formatContentLength = t0;
  return formatContentLength;
}